<template>
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col class="text-center" cols="12" md="8">
          <v-img :src="backgroundImage" alt="Background image" max-height="300" class="mb-5"></v-img>
          <h1 class="display-2 font-weight-bold mb-3">Coming Soon!</h1>
          <h2 class="headline font-weight-normal mb-3">We are working hard to bring you a new experience.</h2>
          <!-- <v-progress-circular
            :rotate="-90"
            :size="100"
            :width="15"
            :value="progress"
            color="primary"
            class="mb-5"
          >{{ remainingDays }} days</v-progress-circular>
          <p class="subtitle-1 mb-5">
            Our website is under construction. We'll be here soon with our new awesome site, subscribe to be notified.
          </p>
          <v-text-field
            solo
            flat
            append-icon="mdi-email"
            placeholder="Enter your email"
            v-model="email"
            class="mb-3"
            @keyup.enter="subscribe"
          ></v-text-field>
          <v-btn large color="secondary" @click="subscribe">Subscribe</v-btn> -->
        </v-col>
      </v-row>
    </v-container>
  </template>
  
  <script>
  export default {
    name: "ComingSoon",
    data() {
      return {
        backgroundImage: require('@/assets/FactsLogoBg.png'), // Ensure the path is correct
        launchDate: new Date('YYYY-MM-DD'), // Set your expected launch date
        email: ''
      };
    },
    computed: {
      remainingDays() {
        const now = new Date();
        const launchDate = new Date(this.launchDate);
        const timeDiff = launchDate - now;
        return Math.max(Math.floor(timeDiff / (1000 * 60 * 60 * 24)), 0);
      },
      progress() {
        const totalDays = (new Date(this.launchDate) - new Date()) / (1000 * 60 * 60 * 24);
        const daysPassed = totalDays - this.remainingDays;
        return (daysPassed / totalDays) * 100;
      }
    },
    methods: {
      subscribe() {
        // Implement your method to handle the subscription logic
        console.log("Subscribed with email:", this.email);
        this.$vuetify.goTo('#');
      }
    }
  };
  </script>
  
  <style scoped>
  </style>
  